module.exports = __webpack_public_path__ + "f37389d65d0e8e99510011006248f8ee.svg";